/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react'
import { Box, Divider } from '@material-ui/core'

import ItemEcommerce from '~/components/Ecommerce/ItemEcommerce'
import track from '~/track'
import { EcommerceContext } from './DrawerEcommerce'
import { OnlineStoreContext } from '../OnlineStorePage'

function storeHadSeen(store) {
  track('lojaOnlineListada', {
    category: 'LojasOnline',
    name: store?.name,
  })
}

function FeaturedManuals({
  hasStoresFeatured,
  hasStoresManuals,
  dataOffersFeatured,
  filteredOffers,
  storesManuals,
  showProductValue,
  openEcommerce,
  handleLogger,
  configEcommerce,
}) {
  return (
    <Box id="fm_google-results-first">
      {hasStoresFeatured && (
        <Box id="fm_featured-stores">
          {dataOffersFeatured?.map((store, index, arr) => (
            <ItemEcommerce
              key={`${store.name}-${index}`}
              store={store}
              product={openEcommerce}
              showValue={showProductValue}
              handleLogger={handleLogger}
              divider={index !== arr.length - 1}
              configEcommerce={configEcommerce}
            />
          ))}
        </Box>
      )}

      <FilteredStores
        hasStoresFeatured={hasStoresFeatured}
        hasStoresManuals={hasStoresManuals}
        filteredOffers={filteredOffers}
        openEcommerce={openEcommerce}
        showProductValue={showProductValue}
        handleLogger={handleLogger}
        configEcommerce={configEcommerce}
        showDivider={hasStoresFeatured}
      />

      {/** Mostrar divisor entre filtered-stores e lojas manuais quando existir ao menos uma das partes anteriores */}
      {hasStoresManuals && (hasStoresFeatured || (filteredOffers && filteredOffers.length > 0)) && (
        <Divider variant="middle" component="li" style={{ backgroundColor: '#EEE', listStyleType: 'none' }} />
      )}

      {hasStoresManuals && (
        <Box id="fm_manuals-stores">
          {storesManuals
            .filter((store) =>
              hasStoresFeatured
                ? !dataOffersFeatured.some((dof) => dof?.name?.toLowerCase() === store.name.toLowerCase())
                : true,
            )
            .map((store, index, arr) => (
              <ItemEcommerce
                isManually
                key={`${store.name}-${index}`}
                store={store}
                product={openEcommerce}
                handleLogger={handleLogger}
                divider={index !== arr.length - 1}
                configEcommerce={configEcommerce}
              />
            ))}
        </Box>
      )}
    </Box>
  )
}

function ManualsFeatured({
  hasStoresFeatured,
  hasStoresManuals,
  dataOffersFeatured,
  storesManuals,
  showProductValue,
  openEcommerce,
  handleLogger,
  configEcommerce,
}) {
  return (
    <Box id="mf_manuals-featured">
      {hasStoresManuals && (
        <Box id="mf_manuals-stores">
          {storesManuals
            .filter((store) =>
              hasStoresFeatured
                ? !dataOffersFeatured.some((dof) => dof?.name?.toLowerCase() === store.name.toLowerCase())
                : true,
            )
            .map((store, index, arr) => (
              <ItemEcommerce
                isManually
                key={`${store.name}-${index}`}
                store={store}
                product={openEcommerce}
                handleLogger={handleLogger}
                divider={index !== arr.length - 1}
                configEcommerce={configEcommerce}
              />
            ))}
        </Box>
      )}

      {hasStoresManuals && (
        <Divider variant="middle" component="li" style={{ backgroundColor: '#EEE', listStyleType: 'none' }} />
      )}

      {hasStoresFeatured && (
        <Box id="mf_featured-stores">
          {dataOffersFeatured?.map((store, index, arr) => (
            <ItemEcommerce
              key={`${store.name}-${index}`}
              store={store}
              product={openEcommerce}
              showValue={showProductValue}
              handleLogger={handleLogger}
              divider={index !== arr.length - 1}
              configEcommerce={configEcommerce}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}

function OnlyStoreManuals({ hasStoresManuals, storesManuals, openEcommerce, handleLogger, configEcommerce }) {
  return (
    <Box id="only-manuals-stores">
      {hasStoresManuals &&
        storesManuals.map((store, index, arr) => (
          <ItemEcommerce
            isManually
            key={`${store.name}-${index}`}
            store={store}
            product={openEcommerce}
            handleLogger={handleLogger}
            divider={index !== arr.length - 1}
            configEcommerce={configEcommerce}
          />
        ))}
    </Box>
  )
}

function OnlyStoreFeatured({
  hasStoresFeatured,
  dataOffersFeatured,
  showProductValue,
  openEcommerce,
  handleLogger,
  configEcommerce,
}) {
  return (
    <Box id="only-featured-stores">
      {hasStoresFeatured &&
        dataOffersFeatured?.map((store, index, arr) => (
          <ItemEcommerce
            key={`${store.name}-${index}`}
            store={store}
            product={openEcommerce}
            showValue={showProductValue}
            handleLogger={handleLogger}
            divider={index !== arr.length - 1}
            configEcommerce={configEcommerce}
          />
        ))}
    </Box>
  )
}

function FilteredStores({
  hasStoresFeatured,
  hasStoresManuals,
  filteredOffers,
  openEcommerce,
  showProductValue,
  handleLogger,
  configEcommerce,
  showDivider = true,
}) {
  return (
    <Box id="filtered-stores">
      {showDivider && (hasStoresFeatured || hasStoresManuals) && (
        <Divider variant="middle" component="li" style={{ backgroundColor: '#EEE', listStyleType: 'none' }} />
      )}

      {filteredOffers
        ?.sort((a, b) => a?.price - b?.price)
        ?.map((store, index, arr) => (
          <ItemEcommerce
            key={`${store.name}-${index}`}
            store={store}
            product={openEcommerce}
            showValue={showProductValue}
            handleLogger={handleLogger}
            divider={index !== arr.length - 1}
            configEcommerce={configEcommerce}
          />
        ))}
    </Box>
  )
}

export default function ListEcommerce({ configEcommerce, openEcommerce, handleLogger }) {
  const ecommerceContext = useContext(EcommerceContext)
  const onlineStoreContext = useContext(OnlineStoreContext)

  const context = ecommerceContext ? ecommerceContext : onlineStoreContext

  const {
    hasStoresFeatured,
    hasStoresManuals,
    isViewLimited,
    isViewOnlyStoresManuals,
    isViewOnlyStoresFeatured,
    showProductValue,
    storesManuals,
    dataOffersFeatured,
    filteredOffers,
    showGoogleResultsFirst,
  } = context

  useEffect(() => {
    if (!isViewLimited || (isViewOnlyStoresManuals && isViewOnlyStoresFeatured)) {
      hasStoresManuals && storesManuals.map(storeHadSeen)
      hasStoresFeatured && dataOffersFeatured.map(storeHadSeen)
    } else {
      isViewOnlyStoresManuals && hasStoresManuals && storesManuals.map(storeHadSeen)
      isViewOnlyStoresFeatured && hasStoresFeatured && dataOffersFeatured.map(storeHadSeen)
    }

    !isViewLimited && filteredOffers?.map(storeHadSeen)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {!isViewLimited || (isViewOnlyStoresManuals && isViewOnlyStoresFeatured) ? (
        <>
          {showGoogleResultsFirst ? (
            <FeaturedManuals
              hasStoresFeatured={hasStoresFeatured}
              hasStoresManuals={hasStoresManuals}
              dataOffersFeatured={dataOffersFeatured}
              filteredOffers={filteredOffers}
              storesManuals={storesManuals}
              showProductValue={showProductValue}
              openEcommerce={openEcommerce}
              handleLogger={handleLogger}
              configEcommerce={configEcommerce}
            />
          ) : (
            <ManualsFeatured
              hasStoresFeatured={hasStoresFeatured}
              hasStoresManuals={hasStoresManuals}
              dataOffersFeatured={dataOffersFeatured}
              storesManuals={storesManuals}
              showProductValue={showProductValue}
              openEcommerce={openEcommerce}
              handleLogger={handleLogger}
              configEcommerce={configEcommerce}
            />
          )}
        </>
      ) : (
        <>
          {isViewOnlyStoresManuals && (
            <OnlyStoreManuals
              hasStoresManuals={hasStoresManuals}
              storesManuals={storesManuals}
              openEcommerce={openEcommerce}
              handleLogger={handleLogger}
              configEcommerce={configEcommerce}
            />
          )}

          {isViewOnlyStoresFeatured && (
            <OnlyStoreFeatured
              showProductValue={showProductValue}
              hasStoresFeatured={hasStoresFeatured}
              dataOffersFeatured={dataOffersFeatured}
              openEcommerce={openEcommerce}
              handleLogger={handleLogger}
              configEcommerce={configEcommerce}
            />
          )}
        </>
      )}

      {!isViewLimited && !showGoogleResultsFirst && (
        <FilteredStores
          hasStoresFeatured={hasStoresFeatured}
          hasStoresManuals={hasStoresManuals}
          filteredOffers={filteredOffers}
          openEcommerce={openEcommerce}
          showProductValue={showProductValue}
          handleLogger={handleLogger}
          configEcommerce={configEcommerce}
        />
      )}
    </>
  )
}
